import { FormEvent, useState } from 'react'
import { ApiError, api } from './api'
import { PulseIcon, ShieldIcon } from './icons'

export function Login({ onAuthenticated }: { onAuthenticated: () => void }) {
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [working, setWorking] = useState(false)

  async function submit(event: FormEvent) {
    event.preventDefault()
    if (!password || working) return
    setWorking(true)
    setError('')
    try {
      await api.login(password)
      onAuthenticated()
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.problem.detail : 'Relay could not sign you in.')
      setPassword('')
    } finally {
      setWorking(false)
    }
  }

  return (
    <main className="login-page">
      <div className="login-ambient ambient-one" />
      <div className="login-ambient ambient-two" />
      <section className="login-card">
        <div className="brand-mark large">
          <PulseIcon />
        </div>
        <div className="login-copy">
          <span className="eyebrow">Private command center</span>
          <h1>Your systems.<br />One clear signal.</h1>
          <p>
            Relay watches every app, every dependency, and every public URL.
            When something needs you, you&rsquo;ll know.
          </p>
        </div>
        <form onSubmit={submit}>
          <label htmlFor="passphrase">Access passphrase</label>
          <div className={`password-field ${error ? 'has-error' : ''}`}>
            <ShieldIcon />
            <input
              id="passphrase"
              autoFocus
              autoComplete="current-password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Enter your private passphrase"
              aria-describedby={error ? 'login-error' : undefined}
            />
          </div>
          {error && <p className="form-error" id="login-error">{error}</p>}
          <button className="primary-button login-button" type="submit" disabled={!password || working}>
            {working ? <span className="button-spinner" /> : 'Enter command center'}
          </button>
        </form>
        <div className="login-trust">
          <ShieldIcon />
          <span>30-day encrypted session · Rate-limited access</span>
        </div>
      </section>
      <footer className="login-footer">
        <span className="live-indicator"><i /> Relay monitor ready</span>
        <span>Built for SASID</span>
      </footer>
    </main>
  )
}
